<script>
    import Modal from "../components/modal/Modal.svelte";
    import Notifier from "../stores/notifier";

    export let orderId;
    export let samples;
    export let selected = [];
    export let closeCallback;

    let list = [];
    let sampleIndex = -1;
    let warning = null;

    const toggleSample = (index, event) => {
        list[index].selected = event.shiftKey ? true : !list[index].selected;
        if (list[index].selected && event.shiftKey && sampleIndex > -1 && sampleIndex < index) {
            for (let i = sampleIndex; i <= index; i++) {
                list[i].selected = true;
            }
        }
        sampleIndex = index;
    }

    const printOrder = () => {
        close({object: 'order', order_id: orderId});
    }

    const printSelectedSamples = () => {
        selected = list.filter(x => x.selected).map(item => (item.id));
        if (!selected.length) {
            Notifier.showError("Δεν έχετε επιλέξει δείγματα για εξαγωγή.");
            return;
        }

        close({object: 'samples', samples: selected});
    }


    const close = (param) => {
        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    samples.map(item => {
        if (item.id) {
            list.push({
                id: item.id,
                code: item.code,
                type: item.type,
                selected: selected.indexOf(item.id) > -1
            });
        } else {
            warning = "Κάποια από τα δείγματα της εντολής δεν έχουν αποθηκευτεί και δεν εμφανίζονται στην επιλογή δειγμάτων.";
        }
    });
</script>

<Modal title="Εξαγωγή Εντολής σε PDF" on:close="{ close }">
    <div slot="body">
        <button class="btn btn-default btn-block mb-3" on:click={ printOrder }>ΕΞΑΓΩΓΗ ΟΛΗΣ ΤΗΣ ΕΝΤΟΛΗΣ</button>
        {#if warning}
            <p style="max-width:410px;">{ warning }</p>
        {/if}
        <div class="samples mb-3">
            {#each list as item, index}
                <div class="sample btn btn-block" class:btn-default={ !item.selected }
                     class:btn-primary={ item.selected } on:click={ (event) => toggleSample(index, event) }>
                    { item.code } <span class="type">{ item.type }</span>
                </div>
            {/each}
        </div>
        <button class="btn btn-default btn-block mb-3" on:click={ printSelectedSamples }>ΕΞΑΓΩΓΗ ΕΠΙΛΕΓΜΕΝΩΝ
            ΔΕΙΓΜΑΤΩΝ
        </button>
    </div>
</Modal>

<style>
    .samples .sample {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 2px;
    }

    .samples .sample .type {
        color: #8f8f8f;
        letter-spacing: -0.5px;
    }

    .samples .sample.btn-primary .type {
        color: #dbdbdb;
    }
</style>